let initial = [];

function listHomeBanners(state = initial, action) {
  switch (action.type) {
    case 'UPDATE_HOME_BANNERS_LIST':
      return action.homeBanners;
    case 'REMOVE_HOME_BANNER':
      return state.filter(item => item.id != action.homeBannerId)
    default:
      return state;
  }
}

export {listHomeBanners};



// WEBPACK FOOTER //
// ./reducers/home-banners.js